import React from 'react';
import { useIsDesktop } from '../../hooks/useIsDesktop';
import { trackCtaClicked } from '../../utils/analytics';

interface HeroBannerProps {
  onCreateClick: () => void;
}

const HeroBanner: React.FC<HeroBannerProps> = ({ onCreateClick }) => {
  const isDesktop = useIsDesktop();

  const handleCreateClick = () => {
    trackCtaClicked();
    onCreateClick();
  };

  return (
    <div className="relative px-4 mb-6 lg:pt-[15px]">
      {/* Purple glow ellipse background */}
      <div
        className="absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 w-[300px] h-[200px] lg:w-[500px] lg:h-[300px] rounded-full blur-[80px] opacity-60 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse at center, rgba(177, 76, 238, 0.6) 70%, rgba(128, 73, 243, 0.4) 80%, transparent 90%)',
        }}
      />

      <div className="relative mt-[40px] rounded-2xl">
        <img
          src={isDesktop ? '/assets/bannerDesktop.png' : '/assets/banner.png'}
          alt="Create your own AI Slut"
          className="relative w-full h-auto lg:w-[550px] block mx-auto"
        />
        <img
          src="/assets/bannerImages.png"
          alt="Create your own AI Slut"
          className="hidden lg:block absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 h-auto banner-overlay-image"
        />
        <img
          src="/assets/line.svg"
          alt=""
          className=" block mx-auto w-[60%] h-auto"
        />
        <div className="absolute inset-0  lg:justify-self-center lg:w-[300px] flex flex-col items-center justify-between mt-[-10px] lg:mt-[-45px] text-center">
          <h1 className="font-anton mt-[-20px] text-white text-3xl uppercase mb-4 leading-tight lg:leading-snug">
            <span className="lg:block">CREATE YOUR</span> OWN{' '}
            <span
              className="text-transparent bg-clip-text"
              style={{
                background:
                  'linear-gradient(100.85deg, #8350CB 4.87%, #FE6283 121.66%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              AI SLUT
            </span>
          </h1>
          <button
            onClick={handleCreateClick}
            className="mb-[-10px] lg:mb-[-20px] w-full bg-gradient-to-r from-[#B14CEE] to-[#8049F3] hover:from-[#9D3DD4] hover:to-[#6C3BDB] active:from-[#8A2FC0] active:to-[#5A2FC7] text-white font-poppins font-bold text-base px-12 py-3 rounded-xl uppercase tracking-wide cursor-pointer transition-all"
            style={{
              boxShadow:
                '0px 0.71px 2.99px 0px rgba(104, 26, 199, 0.31), 0px 3.54px 18.39px 0px rgba(104, 26, 199, 0.61)',
            }}
          >
            Create My Slut
          </button>
        </div>
      </div>
      {isDesktop && (
        <div className="mt-[30px]">
          <img src="/assets/Union.svg" alt="" className="block mx-auto" />
          <img
            src="/assets/Union.svg"
            alt=""
            className="mt-[-26px] block mx-auto "
          />
        </div>
      )}
    </div>
  );
};

export default HeroBanner;
